export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FALIURE = 'CHANGE_PASSWORD_FALIURE'
